import React, { Component } from "react";
import { Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NewPurchase from "./newPurchaseForm";
import NewPurchaseConfirm from "./newPurchaseConfirm";
import AdditionalPurchase from "./additionalPurchaseForm";
import Redemption from "./redemption";
import switchCmponent from "./switch";
import Sip from "./sip";
import Swp from "./swp";
import Stp from "./stp";
import NfoPhysicalMode from "./nfoPhysicalMode";

import SipCancellation from "./sipCancellation";
import NctType from "./nctType";
import ENACH from "./eNach";
import { userPan } from "../../../store/actions/auth";
import EnachConfirm from "./eNachConfirmation";
import Image from "../../Image";

class NFOAndNewPurchaseDigital extends Component {
  async componentDidMount() {
    if (!!this.props.location.state && !!this.props.location.state.pan) {
      await this.props.userPan(this.props.location.state.pan);
    }
  }
  render() {
    const { investorData } = this.props;

    return (
      <div>
        <Paper
          className="digital-form-container"
          style={{ boxShadow: "0px 0px 2px 0px lightgray" }}
        >
          <div className="digital-form-left-div">
            <List
              investorData={investorData}
              pan={!!this.props.user_pan ? this.props.user_pan : ""}
            />
          </div>
          <div className="digital-form-Right-div">
            <Switch>
              <Route
                exact
                path={`/new-transaction/nfo-new-purchase/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/additional-purchase/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/redemption/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/switch/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/sip/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/nfo-new-purchase/digital/transact`}
                component={NewPurchase}
                pan={!!this.props.user_pan ? this.props.user_pan : ""}
              />
              <Route
                exact
                path={`/new-transaction/nfo-new-purchase/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/additional-purchase/digital/transact`}
                component={AdditionalPurchase}
              />
              <Route
                exact
                path={`/new-transaction/additional-purchase/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/redemption/digital/transact`}
                component={Redemption}
              />
              <Route
                exact
                path={`/new-transaction/redemption/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/switch/digital/transact`}
                component={switchCmponent}
              />
              <Route
                exact
                path={`/new-transaction/switch/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/transact`}
                component={Sip}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/sip/digital/modes/enach-folios/transact`}
                component={Sip}
              />

              <Route
                exact
                path={`/new-transaction/sip/digital/modes/transact`}
                component={Sip}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/modes/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/sip/digital/modes/enach-folios/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/swp/digital/transact`}
                component={Swp}
              />
              <Route
                exact
                path={`/new-transaction/swp/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/stp/digital/transact`}
                component={Stp}
              />
              <Route
                exact
                path={`/new-transaction/stp/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/sip-cancellation/digital/transact`}
                component={SipCancellation}
              />
              <Route
                exact
                path={`/new-transaction/sip-cancellation/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/nct-type/digital/transact`}
                component={NctType}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/modes/enach-folios/eNACH`}
                component={ENACH}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/modes/enach-folios/eNACH/confirm`}
                component={EnachConfirm}
              />

              <Route
                exact
                path={`/new-transaction/eNACH/digital/transact`}
                component={ENACH}
              /> 
               <Route
                exact
                path={`/new-transaction/eNACH/digital/transact/confirm`}
                component={EnachConfirm}
              /> 
            </Switch>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { investorData, user_pan } = authReducer;
    return { investorData, user_pan };
  },
  { userPan }
)(NFOAndNewPurchaseDigital);

export class List extends Component {
  render() {
    const { invname, PAN } = this.props.investorData;
    return (
      <div
        style={{
          borderBottom: "1px solid lightgray",
          margin: "0px 10px",
        }}
      >
        <div className="digital-form-investor-list">
          <Image
            src={"/images/user.png"}
            alt="user_icon"
            style={{ height: 35 }}
          />
          <div className="digital-form-text-container">
            <div className="digital-form-main-text">{invname}</div>
            <div className="digital-form-sub-text">
              {" "}
              PAN : {PAN || this.props.pan}
            </div>
          </div>
          {!!this.props.image && (
            <div>
              <Image
                alt="secondary_image"
                src={`${this.props.image}`}
                height={this.props.height}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
